import { storage } from '@/utils/storage';
import jwt_decode from 'jwt-decode';

export const set = property => (state, payload) => (state[property] = payload);

export const toggle = property => state => (state[property] = !state[property]);

export const commitSetter =
  mutation =>
  ({ commit }, payload) =>
    commit(mutation, payload);

export const getShopId = token => {
  try {
    const { shopId } = jwt_decode(token);
    return shopId;
  } catch (_e) {
    if (process.env.NODE_ENV === 'production') {
      sessionStorage.removeItem('vuex');
      localStorage.removeItem('OPW_TOKEN');
      window.open('/dashboard/auth', '_self');
    }
  }
};
